import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","PrivacyPolicyDataId"] */ "/codebuild/output/src2836421981/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
